var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "57px",
    height: "47px",
    viewBox: "0 0 57 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Project-Editor-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1,0 L16.85185,0.47705 C16.0176,5.7528 18.7107,6.3967 23.1945,7.23095 C26.6443,7.8725 30.55,8.69265 30.55,14.94835 L30.55,16.45 L27.76995,16.45 L27.76995,14.94835 C27.76995,11.29175 26.64195,10.6972 22.68455,9.96165 C16.6145,8.83365 13.05895,6.6928 14.1,0 Z M56.4,18.8 L56.4,47 L0,47 L0,18.8 L56.4,18.8 Z M21.15,30.55 L16.45,30.55 L16.45,25.85 L11.75,25.85 L11.75,30.55 L7.05,30.55 L7.05,35.25 L11.75,35.25 L11.75,39.95 L16.45,39.95 L16.45,35.25 L21.15,35.25 L21.15,30.55 Z M30.55,37.6 L25.85,37.6 L25.85,39.95 L30.55,39.95 L30.55,37.6 Z M42.3,32.9 C42.3,31.6028 41.2472,30.55 39.95,30.55 C38.6528,30.55 37.6,31.6028 37.6,32.9 C37.6,34.1972 38.6528,35.25 39.95,35.25 C41.2472,35.25 42.3,34.1972 42.3,32.9 Z M49.35,32.9 C49.35,31.6028 48.2972,30.55 47,30.55 C45.7028,30.55 44.65,31.6028 44.65,32.9 C44.65,34.1972 45.7028,35.25 47,35.25 C48.2972,35.25 49.35,34.1972 49.35,32.9 Z",
    id: "Shape",
    fill: "#828282",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGame);
export default __webpack_public_path__ + "static/media/Game.2f7290fc.svg";
export { ForwardRef as ReactComponent };